<template>
      <CRUDList
      ref="crudList"
      noResultOverride="No fees found"
      :canAdd="false"
      :canEdit="true"
      :canSave="true"
      :showSelect="false"
      :displayTopPagination="false"
      :hideDefaultFooter="true"
      :enableFixedHeaders="true"
      :disableKeyboardFunc="false"
      :headers="headers"
      :selectedItems="selectedItems"
      :baseCrudKey="baseCrudKey"
      :defaultSortBy="defaultSortBy"
      dialogDynamicWidth="23vw"
      tableWrapperDynamicClassname='taxroll-table-wrapper-two'
      tableDynamicHeight='90'
      dialogHeaderName="Fees Form"
      @activateItem="handleAddOrEdit"
      @onDoubleClicked="handleDoubleClick"
      @upsertItem="upsertRecords"
      @emitSelectedItem="emitSelectedItem"
      >
    <template v-slot:[`editedItem`]="{}">
        <TaxFeesTableDialog :baseCrudKey="baseCrudKey" :selectedRowItem="selectedRowItem"/>
      </template>
      <template v-slot:[`additionalActions`]="{}">
        <span>
          <v-row>
           <AuditDialog
            v-if="getActiveTransID"
            :identifier="getActiveTransID"
            activatorCaption="Audit History"
            activatorCaptionStyle = "input-text-size"
          />
          </v-row>
        </span>
      </template>
      <template v-slot:[`additionalActionsAfterDelete`]="{}">
        <v-btn :class="`input-text-size`"
            text color="error darken-1"
            :disabled="showOrHideDelete"
            @click="deleteFromDiaglog"
          >Delete</v-btn>
      </template>
    </CRUDList>
</template>
<script>
import {
  mapMutations, mapActions, mapState,
  mapGetters,
} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import TaxFeesTableDialog from './TaxFeesTableDialog.vue';
import { FeesHeaders } from '../TaxInquiryUtils/TableHeaders.utils';
import { amountFormat, amountToNumber } from '../../../../util/shared/vue-global';
import { toIsoDate, toShortDate } from '../../../../util/shared/tmc-global';
import AuditDialog from '../../../common/audit/AuditDialog.vue';
import { exemptManufacturingStatusCode, penaltyCalculation } from '../../common-utils/tax-common.util';
import { taxFeeCheckWitheEfectiveDate, taxPostProcessFeesList } from '../../common-utils/CommonTaxFunctionalities';
import '../../../../assets/style.css';

export default {
  name: 'TaxRollFeesTable',
  components: {
    CRUDList,
    TaxFeesTableDialog,
    AuditDialog,
  },
  data() {
    return {
      baseCrudKey: 'taxRollFeesTable',
      headers: FeesHeaders,
      feeRecordCounter: 1,
      showOrHideDelete: false,
      activeTransItem: null,
    };
  },
  props: {
    selectedRowItem: {
      type: Object,
      default: () => {},
    },
    mainBaseCrudKey: {
      type: String,
      default: 'TaxInquiryDialog',
    },
    baseCrudKeyForFeeList: {
      type: String,
      default: 'baseCrudKeyForFeeList',
    },
  },
  destroyed() {
  },
  computed: {
    ...mapState({
      StoreSelItems: (state) => state.tax.taxFee.taxRollFeesTable,
      taxFeeList: (state) => state.base.crud.items.sharedTaxFeeMaster,
      isItOmitOrSa: (state) => state.tax.taxFee.isItOmitOrSa,
      taxRollFeesTable: (state) => state.base.crud.items.taxRollFeesTable,
      taxFeeMasterData: (state) => state.shared.taxFeeMaster.taxFeeMasterData,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
    }),
    ...mapGetters('base/crud', [
      'item', 'items',
    ]),
    ...mapGetters([
      'todaysDate',
    ]),
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setTaxRollFeesTable(value);
      },
    },
    itemGetter() {
      const item = this.item(this.baseCrudKey);
      return item;
    },
    getActiveTransID() {
      return this.activeTransItem && this.activeTransItem._id;
    },
    defaultSortBy() {
      return [
        {
          column: 'fees',
          direction: 'desc',
        },
      ];
    },
    editedItems: {
      get() {
        const itemData = this.item('TaxInquiryDialog');
        // currenlty while importing data we are getting 0 as status code . but
        // business team don't want to show so we just remove
        // if (itemData.statusCode && itemData.statusCode.length > 0) {
        //   if (itemData.statusCode[0] === 0) {
        //     delete itemData.statusCode[0];
        //   }
        // }
        return itemData;
      },
      set(value) {
        this.setItem(['TaxInquiryDialog', value]);
      },
    },
  },
  methods: {
    ...mapMutations('tax/taxFee', [
      'setTaxRollFeesTable',
    ]),
    ...mapActions('tax/taxFee', [
      'upsertTaxFees',
      'deleteTaxFees',
      'taxFeesBasedOnIds',
    ]),
    ...mapMutations('base/crud', [
      'setItems',
      'setItem',
      'setIsVisible',
    ]),
    ...mapActions('tax/taxInquires', [
      'upsertTaxInquiryTransaction',
    ]),
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async deleteFromDiaglog() {
      const item = this.itemGetter;
      if (window.confirm('Are you sure you want to delete this item?')) {
        if (item.count && this.isItOmitOrSa) {
          const filteredArray = this.taxRollFeesTable.filter((ft) => ft.count !== item.count);
          this.setItems([this.baseCrudKey, filteredArray]);
          this.setIsVisible([this.baseCrudKey, false]);
        } else {
          const { baseCrudKey } = this;
          await this.deleteTaxFees({ item, baseCrudKey });
          const isExemptManufacturing = (item.statusCode || [])
            .includes(exemptManufacturingStatusCode);
          const getAllFeeTotal = isExemptManufacturing ? 0
            : taxFeeCheckWitheEfectiveDate(this.taxRollFeesTable, this.todaysDate);
          const taxItems = {
            _id: this.selectedRowItem._id,
            totalFee: getAllFeeTotal,
            isItOtherThanTaxInquiryFlag: true,
          };
          const retItem = await this.upsertTaxInquiryTransaction(
            { item: taxItems, baseCrudKey: this.mainBaseCrudKey },
          );
          retItem.totalFee = getAllFeeTotal;
          const processedData = this.taxPostProcessTrans(retItem);
          this.setItem([this.mainBaseCrudKey, processedData || {}]);
          this.$emit('delinquentRefresh');
        }
      }
    },
    taxPostProcessTrans(curitem) {
      // to get the entered penalty and penalty calculation
      const { penaltyDate, penaltyRate } = this.taxSettingItem;
      const item = curitem;
      const returnedVal = penaltyCalculation(
        item.penaltyDateValue, item.penaltyStartDate, penaltyDate,
        item.totalTax, item.totalPaid,
        item.totalFee, penaltyRate, item.totalDue,
        item.taxYear, (item.statusCode || []),
        this.taxSettingItem,
      );
      item.feesAndPen = amountFormat(item.totalDue + returnedVal.penaltyWithOrWithoutFees);
      item.getPenRateWithMonths = returnedVal.getPenRateWithMonths;
      item.penaltyAmount = returnedVal.penaltyAmt;
      return item;
    },
    async upsertRecords(val) {
      const recordItems = this.items(this.mainBaseCrudKey);
      // const recordItem = recordItems.filter((el) => el._id === this.selectedRowItem._id);
      const feeNumber = val.feeNumber ? val.feeNumber : null;
      const filteredTaxMasterList = (this.taxFeeMasterData || [])
        .filter((ft) => ft.feeNumber === feeNumber);
      const feeDesc = filteredTaxMasterList.length > 0
        ? filteredTaxMasterList[0].feeDescription : null;
      if (!this.isItOmitOrSa) {
        if (Object.keys(val).length > 0) {
          const eftDate = val.effectiveDate ? toIsoDate(val.effectiveDate) : null;
          const item = {
            taxYear: val.taxYear,
            taxId: val.taxId,
            effectiveDate: eftDate,
            feeNumber,
            feeAmount: amountToNumber(val.feeAmount),
            feeDescription: feeDesc,
            taxInquiryTransaction: this.selectedRowItem._id,
          };
          if (val._id) item._id = val._id;
          await this.upsertTaxFees({
            item, baseCrudKey: this.baseCrudKey, postProcessTrans: this.taxFeesPostProcessTrans,
          }).then(() => {
            const emptyObj = { feeAmount: null, feeNumber: 0 };
            this.setItem([this.baseCrudKey, emptyObj]);
          });
          // to fetch fee with effective date for penalty calculation
          const filterUnPaidTaxes = (recordItems || [])
            .filter((ft) => amountToNumber(ft.totalDue) > 0);
          if (filterUnPaidTaxes.length) {
            await this.taxFeesBasedOnIds(
              {
                criteria: { ids: [this.selectedRowItem._id] },
                baseCrudKey: this.baseCrudKeyForFeeList,
                postProcessTrans: taxPostProcessFeesList,
              },
            );
          }
          const isExemptManufacturing = (item.statusCode || [])
            .includes(exemptManufacturingStatusCode);
          const getAllFeeTotal = isExemptManufacturing ? 0
            : taxFeeCheckWitheEfectiveDate(this.taxRollFeesTable, this.todaysDate);
          const taxItems = {
            _id: this.selectedRowItem._id,
            totalFee: getAllFeeTotal,
            isItOtherThanTaxInquiryFlag: true,
          };
          const retItem = await this.upsertTaxInquiryTransaction(
            { item: taxItems, baseCrudKey: this.mainBaseCrudKey },
          );
          // retItem.penaltyDateValue = recordItem[0].penaltyDateValue;
          retItem.totalFee = getAllFeeTotal;
          const processedData = this.taxPostProcessTrans(retItem);
          this.setItem([this.mainBaseCrudKey, processedData || {}]);
        }
      } else {
        let itemsList = [];
        const existingUpdateArray = this.taxRollFeesTable
          .map((ft) => (ft.count === val.count ? val : ft));
        if (val.count && existingUpdateArray.length > 0) {
          // updating existing records
          itemsList = existingUpdateArray;
        } else {
          // adding existing records
          const item = { ...val };
          item.feeDescription = feeDesc;
          item.count = this.feeRecordCounter;
          itemsList = [...this.taxRollFeesTable, item];
          this.feeRecordCounter += 1;
        }
        const emptyObj = { feeAmount: null, feeNumber: 0 };
        this.setItem([this.baseCrudKey, emptyObj]);
        this.setItems([this.baseCrudKey, itemsList]);
      }
    },
    taxFeesPostProcessTrans(items) {
      const updatedItems = [];
      for (let i = 0; i < items.length; i += 1) {
        const item = { ...items[i] };
        item.effectiveDate = item.effectiveDate ? toShortDate(item.effectiveDate)
          : item.effectiveDate;
        item.paymentDate = item.paymentDate ? toShortDate(item.paymentDate)
          : item.paymentDate;
        updatedItems.push(item);
      }
      return updatedItems;
    },
    handleDoubleClick() {
      const selItem = this.itemGetter;
      if (selItem.isPaid) this.showOrHideDelete = true;
      else this.showOrHideDelete = false;
    },
    handleAddOrEdit(item, addOrEdit) {
      if (addOrEdit === 'newItem') this.showOrHideDelete = true;
      this.activeTransItem = item;
    },
    handleFeeNewItem() {
      const selectItem = {
        taxId: this.selectedRowItem.taxId,
        taxYear: this.selectedRowItem.taxYear,
      };
      this.$refs.crudList.handleNewItem(selectItem);
    },
  },
};
</script>
